export default function isFullSentence(text?: string): boolean {
  if (!text) return false;
  
  // Trim trailing newlines if present
  const trimmedText = text.replace(/\n+$/, '');
  
  // Check if the trimmed text ends with a period, exclamation mark, or question mark
  return /[.!?]$/.test(trimmedText);
}
